(function () {
  'use strict';
  var cache = new Map(), inFlight = new Set();
  function render(card, own, supplier, reservable) {
    var label = card.querySelector('[data-lbx-store-availability]');
    if (!label) return;
    var active = own <= 0 && supplier <= 0 && reservable;
    var wasActive = label.classList.contains('is-hub-reservation');
    label.classList.toggle('is-hub-reservation', !!active);
    if (!active && !wasActive) return;
    label.classList.remove('is-sold-out', 'is-out-of-stock', 'is-available', 'is-supplier');
    label.classList.add(active ? 'is-reservation' : own > 0 ? 'is-available' : supplier > 0 ? 'is-supplier' : 'is-sold-out');
    if (!active) label.classList.remove('is-reservation');
    var copy = label.querySelector('.lbx109-stock-copy');
    if (!copy) return;
    var title = copy.querySelector('b'), detail = copy.querySelector('small');
    if (title) title.textContent = active || own > 0 || supplier > 0 ? 'Disponible' : 'Sin stock';
    var text = active ? 'Bajo reserva previa' : own > 0 ? '' : supplier > 0 ? 'Entrega en 10 días laborables' : '';
    if (text && !detail) { detail = document.createElement('small'); copy.appendChild(detail); }
    if (detail) { if (text) detail.textContent = text; else detail.remove(); }
    card.setAttribute('data-lbx-product-stock-status', active ? 'reservation' : own > 0 ? 'in-stock' : supplier > 0 ? 'supplier-stock' : 'sold-out');
    card.setAttribute('data-lbx-availability', card.getAttribute('data-lbx-product-stock-status'));
  }
  window.lbxHubAvailability = { render: render };
  function apply() {
    document.querySelectorAll('[data-lbx-hub-product-id]').forEach(function (card) {
      var item = cache.get(card.getAttribute('data-lbx-hub-product-id'));
      if (!item) return;
      card.__lbxHubReservable = item.ids;
      // Exact selected size/color is resolved by the catalogue controller.
      if (!card.closest('[data-lbx-catalog]')) render(card, Number(card.getAttribute('data-lbx-own-stock') || 0), Number(card.getAttribute('data-lbx-supplier-stock') || 0), card.__lbxHubReservable.length > 0);
    });
    document.dispatchEvent(new CustomEvent('lbx:hub-availability'));
  }
  async function refresh() {
    var ids = Array.from(new Set(Array.from(document.querySelectorAll('[data-lbx-hub-product-id]')).map(function (card) { return card.getAttribute('data-lbx-hub-product-id'); })))
      .filter(function (id) { return /^\d+$/.test(id) && !inFlight.has(id) && (!cache.has(id) || cache.get(id).until <= Date.now()); });
    apply();
    for (var i = 0; i < ids.length; i += 48) {
      var group = ids.slice(i, i + 48);
      group.forEach(function (id) { inFlight.add(id); });
      try {
        var response = await fetch('https://labosch-reservas-app.vercel.app/api/public/preorders/availability?productIds=' + group.join(','), { signal: AbortSignal.timeout(10000) });
        if (!response.ok) throw new Error('availability');
        var data = await response.json();
        group.forEach(function (id) { cache.set(id, { until: Date.now() + 30000, ids: Array.isArray(data.products[id]) ? data.products[id] : [] }); });
      } catch (_) { group.forEach(function(id){cache.set(id,{until:Date.now()+10000,ids:[]});}); }
      finally { group.forEach(function (id) { inFlight.delete(id); }); }
    }
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
  ['lbx:catalog-updated', 'lbx:offer-catalog-ready', 'shopify:section:load'].forEach(function (name) { document.addEventListener(name, refresh); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  setInterval(function () { if (!document.hidden) refresh(); }, 30000);
})();
